function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { Controller } from 'react-hook-form';
import { CloseButton, TextField, Typography } from 'seagull';
import { isUrlValid } from "./IntroVIdeoModal.utils";
import VideoPlayer, { isStatusSuccess, VideoPlayerStatus } from "../../../../VideoPlayer/VideoPlayer";
import { connectControllerToTextField } from "../../../../../utils/react-hook-form.utils";
import styles from "./IntoVideoModal.module.scss";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
const IntroVideoModalContent = _ref => {
  let {
    form,
    setInputVideoName,
    setVideoPlayableStatus,
    videoPlayableStatus
  } = _ref;
  const handleReady = () => {
    form.clearErrors();
    setVideoPlayableStatus(VideoPlayerStatus.SUCCESS);
  };
  const handleError = status => {
    setVideoPlayableStatus(status);
  };
  const onReady = _ref2 => {
    let {
      videoName
    } = _ref2;
    handleReady();
    setInputVideoName(videoName);
  };
  const validateVideoLinkField = videoLinkToValidate => {
    if (!isUrlValid(videoLinkToValidate)) {
      setInputVideoName('');
      return 'URL is invalid';
    }
    switch (videoPlayableStatus) {
      case VideoPlayerStatus.NOT_FOUND:
        {
          setInputVideoName('');
          return 'Video was not found';
        }
      case VideoPlayerStatus.ACCESS_DENIED:
        {
          setInputVideoName('');
          return "Unable to access the video. Please check the video's privacy settings.";
        }
      case VideoPlayerStatus.SUCCESS:
      default:
        return;
    }
  };
  return /*#__PURE__*/_jsxs("div", {
    className: styles.contentContainer,
    children: [/*#__PURE__*/_jsx(Typography, {
      children: "Paste the video URL from Youtube, Vimeo or Loom"
    }), /*#__PURE__*/_jsx(Controller, {
      control: form.control,
      name: "videoLink",
      rules: {
        validate: value => validateVideoLinkField(value)
      },
      render: p => /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(TextField, _objectSpread({
          collapseHelperText: false,
          testId: "intro-video-modal-url-field",
          placeholder: "Video URL",
          autoFocus: true,
          suffix: /*#__PURE__*/_jsx(CloseButton, {
            testId: "intro-video-modal-remove-video-name-button",
            skin: "transparent",
            onClick: () => {
              setInputVideoName('');
              form.setValue('videoLink', '');
            }
          })
        }, connectControllerToTextField(p))), isUrlValid(p.field.value) && /*#__PURE__*/_jsx("div", {
          "data-testid": "intro-video-modal-video-player",
          style: {
            display: isStatusSuccess(videoPlayableStatus) ? 'inherit' : 'none',
            minHeight: 300
          },
          children: /*#__PURE__*/_jsx(VideoPlayer, {
            url: p.field.value,
            onError: handleError,
            onReady: onReady
          })
        })]
      })
    })]
  });
};
export default IntroVideoModalContent;